import { html, SYSFormElement, unsafeHTML } from "../../../../../_ovlclient/src"

import {
  FormIsLocked,
  FormIsValid,
} from "../../../../../_ovlclient/src/library/forms/formapi"

import { T } from "../../../../../_ovlclient/src/textapi"
import { FormHandlingType } from "../../../../src/library/dialog/sysdialogbase"
import { SYSFormField } from "../../../../src/library/forms/fieldapi"
import { isTracking } from "../../../../src/tracker/tracker"
import { SYSUserSettingsPassword } from "../features/allactions"
export class CompSYSUserSettingsPasswordForm extends SYSFormElement {
  mode: "PwReset"
  resetId: string
  resetToken: string
  resetFirstName: string
  resetLastName: string
  userSettingsPasswordActions: typeof SYSUserSettingsPassword
  async init() {
    let fields: { [key: string]: SYSFormField } = {
      pw: {
        value: "",
        ui: {
          labelTranslationKey: "SYSLoginPassword",
          isPassword: true,
          fillSpaceIfNotVisible: false,
        },
      },
      pw1: {
        value: "",
        ui: {
          labelTranslationKey: "SYSLandingPage01PasswordNew",
          isPassword: true,
        },
      },
      pw2: {
        value: "",
        ui: {
          labelTranslationKey: "SYSLandingPage01PasswordNewConfirmation",
          isPassword: true,
        },
      },
    }

    if (this.mode === "PwReset") {
      let resetParts = this.resetId.split("_")
      this.resetToken = resetParts.slice(0, 3).join("_")
      this.resetFirstName = resetParts[3]
      this.resetLastName = resetParts[4]
      fields["pw"].value = this.resetId
      fields["pw"].ui.visible = "false"
    }

    this.formHandling = <FormHandlingType>{
      formType: "SYSUserSettingsPassword",
      creation: { autoInitFormFields: fields },
    }

    this.userSettingsPasswordActions = (<any>(
      this.actions.app.features
    )).SYSUserSettingsPassword
    await super.init()
  }
  async getUI() {
    let handleSave = async (e) => {
      e.preventDefault()
      await this.userSettingsPasswordActions.actions.SaveSettings({
        formState: this.formState,
        mode: this.mode,
      })
    }

    // this is just a helper fn to get typed ids

    let fields = this.formState.fields
    let pwField = fields["pw"]
    let pw1Field = fields["pw1"]
    let pw2Field = fields["pw2"]

    let title = T("SYSLandingPage01ChangePw")
    if (this.mode === "PwReset") {
      title = T("SYSLandingPage01PasswordResetTitle", [
        this.resetFirstName,
        this.resetLastName,
      ])
    }
    let pw2FieldHtml = null
    if (!this.state.ovl.app.enablePasswordVisibility) {
      pw2FieldHtml = html`
        <div class="fd-form-item">
          <ovl-textbox .props=${() => pw2Field} }}> </ovl-textbox>
        </div>
      `
    }
    return html`
      <form class="settingsform">
        <div class="fd-layout-panel">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3>
                ${unsafeHTML(title)}
              </h3>
            </div>
          </div>

          <div class="fd-layout-panel__body">
            <div class="fd-form__group">
              <div class="fd-form-item ">
                <ovl-textbox .props=${() => pwField}> </ovl-textbox>
              </div>
              <div class="fd-form-item">
                <ovl-textbox .props=${() => pw1Field}> </ovl-textbox>
              </div>
              ${pw2FieldHtml}
              <ovl-passwordvisibility></ovl-passwordvisibility>
            </div>
            <ovl-formvalidationhint
              .props=${() => this.formState}
            ></ovl-formvalidationhint>
          </div>
          <div
            class="fd-layout-panel__footer fd-has-padding-base fd-has-margin-base"
          >
            <div class="fd-layout-panel__actions">
              <button
                ?disabled=${FormIsLocked(this.formState) ||
                !FormIsValid(this.formState)}
                @click=${async (e) => await handleSave(e)}
                class="fd-button"
              >
                ${this.mode === "PwReset"
                  ? T("SYSOk")
                  : T("SYSLandingPage01ChangePw")}
              </button>
            </div>
          </div>
        </div>
      </form>
    `
  }
}
